import React, { createContext, useContext, useState } from 'react';
import PropTypes from 'prop-types';
import { endpointOwlApc } from './customers/endpoint.ts';

export const OwlApcContext = createContext({});

const OwlApcProvider = ({ children }) => {
  const [job, setJob] = useState(null);
  // const [saveError, setSaveError] = useState(false);

  async function welcomeHandler(answer, { id, skey }) {
    console.log('welcomeHandler', answer || 'no change');
    const response = await fetch(`${endpointOwlApc}/job/${id}/${skey}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        customerAnswered01welcome: {
          address: answer?.address,
          textOK: answer ? answer.textOK : true,
          noChange: !answer
        }
      })
    });
    console.log(response);
    // console.log(await response.text());
    return response.ok;
  }

  const value = { job, setJob, welcomeHandler };
  return (
    <OwlApcContext.Provider value={value}>{children}</OwlApcContext.Provider>
  );
};

OwlApcProvider.propTypes = {
  children: PropTypes.node.isRequired
};

export const useOwlApcContext = () => useContext(OwlApcContext);

export default OwlApcProvider;
